import { Component } from '@theme/component';

class EscProductRecommendations extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#loadRecommendations();
  }

  #loadRecommendations() {
    const { productId, recommendationsPerformed, sectionId, intent } = this.dataset;

    if (!productId || !sectionId) {
      throw new Error('Product ID and a section ID are required');
    }

    if (recommendationsPerformed === 'true') {
      return;
    }

    this.#fetchRecommendations(productId, sectionId, intent)
      .then((result) => {
        if (!result.success) {
          // The Theme Editor will place a section element element in the DOM whose section_id is not available
          // to the Section Renderer API. In this case, we can safely ignore the error.
          if (!Shopify.designMode) {
            //
          }
          
          return;
        }

        if (result.data?.trim().length) {
          this.dataset.recommendationsPerformed = 'true';
          const fragment = new DOMParser().parseFromString(result.data, 'text/html')
          const parsedNewTree = fragment.body.firstChild;
          const recommendationsContent = parsedNewTree.querySelector(`#${this.id}`);
          
          this.#injectStylesheets(fragment);

          this.innerHTML = recommendationsContent.innerHTML;
         // Render the response
        } else {

        }
      });
  }
   /**
   * Fetches the recommendations
   * @param {string} productId
   * @param {string | undefined} sectionId
   * @param {string | undefined} intent
   * @returns {Promise<{ success: true, data: string } | { success: false, status: number }>}
   */
  async #fetchRecommendations(productId, sectionId, intent) {
    const url = `${this.dataset.url}&product_id=${productId}&section_id=${sectionId}&intent=${intent}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        return { success: false, status: response.status };
      }

      const text = await response.text();

      return { success: true, data: text };
    } finally {
    }
  }

  #injectStylesheets(fragment) {
    const section = this.closest('.shopify-section');
    const allNewStylesheets = fragment.querySelectorAll('style');

    allNewStylesheets.forEach(stylesheet => {
      section?.prepend(stylesheet);
    });
  }
}

if (!customElements.get('esc-product-recommendations')) {
  customElements.define('esc-product-recommendations', EscProductRecommendations);
}
